import { AccessBoundary } from '@/features/access/AccessBoundary';
import { Outlet } from 'react-router';

/** Espace de travail plein écran pour les éditeurs, indépendant d’AppLayout. */
export const FullscreenLayout = () => (
  <main className="bg-canvas min-h-dvh w-full min-w-0 px-4 py-6 sm:px-6 lg:px-8">
    <AccessBoundary>
      <Outlet />
    </AccessBoundary>
  </main>
);
